import React, { useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import Modal from "../components/modals/Modal";
import { IconAlertSmall } from "@tabler/icons-react";

const UzemiKerdes = () => {
	const { order, updateOrder } = useOrder();
	const aktVeny = order.venyek[order.aktivVenyIndex] || {};
	const navigate = useStepNavigate();
	const [veny_indstrl_accdnt, setNaploszam] = useState(aktVeny.veny_indstrl_accdnt || "");
	const [showModal, setShowModal] = useState(false);

	const updateAktualisVeny = (ujAdatok) => {
		updateOrder((prev) => {
			const venyek = [...prev.venyek];
			venyek[prev.aktivVenyIndex] = { ...venyek[prev.aktivVenyIndex], ...ujAdatok };
			return { ...prev, venyek };
		});
	};

	const handleInputChange = (e) => {
		setNaploszam(e.target.value);
		updateAktualisVeny({
			veny_indstrl_accdnt: e.target.value,
		});
	};

	const handleSubmit = () => {
		if (!veny_indstrl_accdnt) {
			setShowModal(true);
			return;
		}
		updateAktualisVeny({
			veny_indstrl_accdnt,
		});
		if (order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
			navigate("/BetetTartozek");
		} else {
			navigate("/Mennyiseg");
		}
	};

	const handleModalYes = () => {
		updateOrder((prev) => {
			const venyek = [...prev.venyek];
			venyek[prev.aktivVenyIndex] = {
				...venyek[prev.aktivVenyIndex],
				veny_indstrl_accdnt: "",
				hmeliorder_specaidtype: 1,
			};
			return {
				...prev,
				hmeliorder: {
					...prev.hmeliorder,
					hmeliorder_specaidtype: 1,
					hmeliorder_specaidtype_national: "Normatív",
				},
				venyek,
			};
		});
		setShowModal(false);
		if (order.hmeliorder?.hmeliorder_depot_prefix === "BETÉT") {
			navigate("/BetetTartozek");
		} else {
			navigate("/Mennyiseg");
		}
	};

	return (
		<TablerLayout title="Üzemi baleset adatok">
			<div className="row justify-content-center" style={{ filter: showModal ? "blur(3px)" : "none" }}>
				<div className="col-md-10 mb-4">
					<div className="card-body">
						<div className="mb-3">
							<label className="form-label">
								Üzemi baleset naplószáma: <span className="text-danger">*</span>
							</label>
							<input type="text" className="form-control" name="veny_indstrl_accdnt" value={veny_indstrl_accdnt} onChange={handleInputChange} required />
						</div>
					</div>
				</div>

				<div className="d-flex justify-content-between mt-4">
					<StepperNavButton side="left" label="Vissza" onClick={() => navigate("/AdatVenyes")} />
					<StepperNavButton side="right" label="Tovább" onClick={handleSubmit} />
				</div>
			</div>

			<Modal isOpen={showModal} onClose={() => setShowModal(false)} onConfirm={handleModalYes} title="Normatív rendelés?" type="warning" confirmText="Igen" secondaryText="Nem" confirmClass="btn btn-primary" secondaryClass="btn btn-danger" showSecondary={true} showCancel={true} icon={<IconAlertSmall size={70} stroke={2} className="text-warning" />}>
				<h4>
					Nincs megadva naplószám.
					<br />
				</h4>
				<h5>Kívánja normatív vényként rögzíteni?</h5>
			</Modal>
		</TablerLayout>
	);
};

export default UzemiKerdes;
